const initMobileMenu = () => {
  const el = {
    parentNav: '.mobile-menu-parent-item.mobile-menu-collapse-button',
    collapseCnt: '.mobile-menu-collapsable-block',
    collapseCntActive: '.mobile-menu-collapsable-block.active',
    backMenu: '.submenu-back',
    subMenuItem: '.mobile-menu-sub-item',
    subMenuExpand: '.submenu-expand'
  }

  document.querySelectorAll(el.parentNav).forEach((p_nav) => {
    p_nav.addEventListener('click', () => {
      let target = p_nav.dataset.target;
      let targetCnt = document.querySelector(`${el.collapseCnt}[data-handle="${target}"]`);
      if(targetCnt) {
        targetCnt.classList.add('active');
      }
    })
  })

  document.querySelectorAll(el.backMenu).forEach((back) => {
    back.addEventListener('click', () => {
      back.closest(el.collapseCnt).classList.remove('active');
    })
  })

  document.querySelectorAll(el.subMenuExpand).forEach((expand) => {
    expand.addEventListener('click', (e) => {
      e.preventDefault();
      expand.closest(el.subMenuItem).classList.toggle('expand');
    })
  })

}

const scrollButton = () => {

  let offset = 0;
  let spacing_offset = 0;
  if(window.innerWidth < 768) {
    // spacing_offset = 115;
  }

  document.querySelectorAll('.page-scroll-button').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      let target = document.querySelector(`${button.dataset.target}`).closest('.shopify-section') || document.querySelector(`${button.dataset.target}`);

      $("html, body").animate({
        scrollTop: target.offsetTop - spacing_offset
      }, 1500);

    })
  })
}

const initDiviPopup = () => {
  document.querySelectorAll('[data-divi-popup-open]').forEach((open) => {
    open.addEventListener('click', () => {
      let target = open.dataset.target;
      let popup = document.querySelector(`divi-popup[data-handle="${target}"]`);
      if(popup) {
        popup.classList.add('open');
      }
    })
  })
  document.querySelectorAll('[data-divi-popup-close]').forEach((close) => {
    close.addEventListener('click', () => {
      let popup = document.querySelector(`divi-popup.open`);
      if(popup) {
        popup.classList.remove('open');
      }
    })
  })
}

const initPDPVariantSpecificImages = () => {
  if(document.body.classList.contains('template-product')) {
    let is_alt_img_slider = false;
    let mainSwiperHtm = '', thumbSwiperHtm = '';
    let elSwiperMain = '', elSwiperThumb = '';

    if(document.querySelector('.product-section-block').classList.contains('variant-specific-image')) {
      is_alt_img_slider = true;
      elSwiperMain = document.querySelector('[data-product-swiper-main]');
      elSwiperThumb = document.querySelector('[data-product-swiper-thumbs]');
      mainSwiperHtm = elSwiperMain.innerHTML;
      thumbSwiperHtm = elSwiperThumb.innerHTML;
    }

    function genSwiperContents() {
      let activeSwatch = document.querySelector('[data-product-swatch-input]:checked').value.toLowerCase().replace(' ', '-');

      elSwiperMain.innerHTML = mainSwiperHtm;
      elSwiperThumb.innerHTML = thumbSwiperHtm;

      elSwiperMain.querySelectorAll('[data-swiper-media]').forEach((media) => {
        let alt = media.dataset.mediaAlt.toLowerCase().replace(' ', '-');
        if(activeSwatch != alt) {
          media.remove();
        }
      })
      elSwiperThumb.querySelectorAll('[data-swiper-media]').forEach((media) => {
        let alt = media.dataset.mediaAlt.toLowerCase().replace(' ', '-');
        if(activeSwatch != alt) {
          media.remove();
        }
      })
    }

    function initSlider() {
      if(is_alt_img_slider || document.querySelector('[data-product-swatch-input]:checked')) {
        genSwiperContents();
      }

      var swiper = new Swiper('.product-section-block .swiper-mini', {
        spaceBetween: 6,
        slidesPerView: 5.5,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.product-section-block .swiper-mini .swiper-button-next',
          prevEl: '.product-section-block .swiper-mini .swiper-button-prev',
        },
          breakpoints: {
          768: {
            spaceBetween: 4,
            slidesPerView: 6,
          },
        },
      });
      var swiper2 = new Swiper('.product-section-block .swiper-full', {
        spaceBetween: 10,
        thumbs: {
          swiper: swiper,
        },
        breakpoints: {
          // when window width is >= 320px
          310: {
            slidesPerView: 1.1,
            spaceBetween: 4,
          },
          // when window width is >= 480px
          768: {
            slidesPerView: 1,
            spaceBetween: 4,
          },
        },
      });

      swiper2.on('slideChange', (e, a, b) => {
        setTimeout(() => {
          let activeSlide = document.querySelector('.product-section-block .swiper-full .swiper-slide-active');
          let activeVideo = document.querySelector('.product-section-block .swiper-full .product-media-video.active');
          if(activeVideo) {
            activeVideo.classList.remove('active');
            activeVideo.querySelector('video').pause();
          }
          if(activeSlide && activeSlide.querySelector('video')) {
            activeSlide.querySelector('.product-media-video').classList.add('active');
            activeSlide.querySelector('video').play();
          }
        }, 500);
      })
    }
    if (Shopify.designMode) {
      initSlider();
      document.addEventListener('shopify:section:load', function (e) {
        initSlider();
      });
    } else {
      initSlider();
    }

    document.querySelectorAll('[data-product-swatch-input]').forEach((swatchInput) => {
      swatchInput.addEventListener('change', () => {
        initSlider();
      })
    })
  }
}

window.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  scrollButton();
  initDiviPopup();
  initPDPVariantSpecificImages();
})